import { 
    // 取得電子發票清單
    apiBizGetEinvoiceList,
    //下載發票
    apiBizGetEinvoicePDF,
    //電子發票年份清單
    apiBizGetEinvoiceYear
} from "@/apis/api.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_einvoice_list: 'wallet/set_einvoice_list',
    set_einvoice_year: 'wallet/set_einvoice_year',
}

// count state 必須是 Object
const state = {
    einvoiceList: [],
    einvoiceYear: [],
    filter: {
        allRecord: {
            // page: 1,
            period: ['',''],
            item: '',
            withdraw: ''
        }
    },
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_EINVOICE_LIST: (state) => {
        return state.einvoiceList
    },
    GET_BIZ_EINVOICE_YEAR: (state) => {
        return state.einvoiceYear
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizEinvoiceList({ commit }, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetEinvoiceList(data)
            .then(res => {
                console.log(res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_einvoice_list, res.data.result);
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizEinvoiceYear({ commit }, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetEinvoiceYear(data)
            .then(res => {
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_einvoice_year, res.data.result);
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
    getBizEinvoicePDF({ commit }, data ) {
        return new Promise((resolve, reject) => {
            apiBizGetEinvoicePDF(data)
            .then(res => {
                console.log(res)
                if(res.status == 200){
                    // window.open(res.data);
                    // var blob = new Blob([res.data], { type: 'application/pdf' });
                    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf;charset-UTF-8' }));
                    window.open(url);
                    resolve()
                }
            })
            .catch(err =>{
                reject(err)
            })
        })
    },
}
// mutations
const mutations = {
    [types.set_einvoice_list](state, data){
        state.einvoiceList = data
    },
    [types.set_einvoice_year](state, data){
        state.einvoiceYear = data
    },
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/settingCenter/einvoice/einvoice.js